import { render, staticRenderFns } from "./AssetReg.vue?vue&type=template&id=9ea896d2&"
import script from "./AssetReg.vue?vue&type=script&lang=js&"
export * from "./AssetReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports